module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rounded-b relative h-48",
    class: [_vm.co_teacher_tap_in ? 'h-56 flex justify-center w-96' : 'bg-gray-100']
  }, [_c('div', {
    staticClass: "absolute left-0 bottom-0 top-0 right-0 z-10 w-full h-full"
  }, [_c('div', {
    staticClass: "relative w-full h-full"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-2 h-full"
  }, [_c('div', {
    staticClass: "font-poppins text-xs py-0.5 text-white text-center",
    class: {
      'bg-gray-300 bg-opacity-50 backdrop-blur-lg': _vm.cameraOn,
      'bg-gray-800 bg-opacity-50 backdrop-blur-lg': !_vm.cameraOn
    }
  }, [_vm._v("\n          Teacher\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between items-center"
  }, [(_vm.speaking_teachers[_vm.coteacher.id]) ? _c('div', [_c('VolumeIndicator')], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-grow px-2 h-full w-full",
    on: {
      "mouseover": function($event) {
        _vm.isToSeeSettings = true
      },
      "mouseleave": function($event) {
        _vm.isToSeeSettings = false
      }
    }
  }, [_c('div', {
    staticClass: "flex justify-center items-center w-full"
  }, [(_vm.video_audio_is_active && _vm.joinedAudioDiscussion && _vm.is_my_coteacher && _vm.cameraOn && _vm.isToSeeSettings) ? _c('button', {
    staticClass: "flex justify-center text-center items-center bg-gray-500 bg-opacity-50 h-10 w-10 rounded-full",
    on: {
      "click": function($event) {
        return _vm.openDeviceSettings()
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-gear text-white text-center text-lg"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-between pb-2 px-2"
  }, [_c('div', {
    staticClass: "flex space-x-1.5 bg-gray-800 bg-opacity-50 rounded-full px-3 py-1.5 h-7 items-center"
  }, [_c('div', {
    staticClass: "truncate text-white max-width-name text-xs"
  }, [_c('span', [_vm._v(_vm._s(_vm.coteacher.name))]), _vm._v(" "), _c('span', {
    staticClass: "text-pinky ml-0.5"
  }, [_vm._v("(Me)")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "absolute",
    staticStyle: {
      "top": "calc(50% - 40px)",
      "left": "calc(50% - 40px)"
    }
  }, [_c('img', {
    staticClass: "rounded-full object-cover",
    style: ({
      width: _vm.co_teacher_tap_in ? '90px' : '70px',
      height: _vm.co_teacher_tap_in ? '90px' : '70px',
    }),
    attrs: {
      "src": _vm.coteacher.avatar_url
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-18717e52!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/LDDiscussionCoTeacherCircle.vue
// module id = 1777
// module chunks = 61